import React from 'react'
import './index.css'
import ButtonLink from 'components/ButtonLink'
import { ROUTE_PATH } from 'modules/route/constants'
import View from 'components/View'
import H2 from 'components/H2'
import P from 'components/P'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import useIsMediumScreen from 'hooks/use-is-medium-screen'
import setShouldScrollToReferAFriendAfterSignInUtil from 'pages/Squad/utils/set-scroll-to-refer-a-friend-after-sign-in'
import { LOYALTY_REFER_A_FRIEND_PERCENTAGE_OFF_LABEL } from 'modules/loyalty/constants'

const TITLE = `Refer a friend and get ${LOYALTY_REFER_A_FRIEND_PERCENTAGE_OFF_LABEL}!`
const DESCRIPTION = 'Refer 5 friends to unlock Gold loyalty status, and 10 to unlock Diamond.'
const REFER_A_FRIEND = 'Refer a friend'

const ANALYTICS_EVENT = {
  SHOW_REFER_A_FRIEND_ALERT: 'SHOW_REFER_A_FRIEND_ALERT',
  ADD_FRIEND_FROM_REFER_A_FRIEND_ALERT: 'ADD_FRIEND_FROM_REFER_A_FRIEND_ALERT'
}

export default function AddYourFirstFriendToYourSquadContent (props) {
  logUtil('AddYourFirstFriendToYourSquadContent').debug('[start] props=', props)
  const { showRatingCardOnMobile } = props
  const handleClickAddAFriend = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.ADD_FRIEND_FROM_REFER_A_FRIEND_ALERT)
    setShouldScrollToReferAFriendAfterSignInUtil()
  }
  const isMediumScreen = useIsMediumScreen()

  return (
    <section className='add-your-first-friend-to-your-squad'>
      <View className='page-width'>
        <View className='add-your-first-friend-to-your-squad-content'>
          {!isMediumScreen && (
            <View className='add-your-first-friend-to-your-squad-rating-card-image'>
              <img src='https://cdn.shopify.com/s/files/1/0569/9957/5718/files/Rating_cardx_73e94f30-deea-492d-9335-7fb2b3055da0.png?v=1695058005' />
            </View>
          )}
          <View className='add-your-first-friend-to-your-squad-content-text'>
            <View className='add-your-first-friend-to-your-squad-friends-image'>
              <img src='https://cdn.shopify.com/s/files/1/0569/9957/5718/files/friends.png?v=1695058440' />
            </View>
            <H2 className='add-your-first-friend-to-your-squad-title'>
              {TITLE}
            </H2>
            <P className='add-your-first-friend-to-your-squad-description'>
              {DESCRIPTION}
            </P>
            <View className='add-your-first-friend-to-your-squad-buttons'>
              <ButtonLink
                className='add-your-first-friend-to-your-squad-button-join btn'
                onClick={handleClickAddAFriend}
                href={ROUTE_PATH.ACCOUNT_LOYALTY}
              >
                {REFER_A_FRIEND}
              </ButtonLink>
            </View>
          </View>
          {isMediumScreen && showRatingCardOnMobile && (
            <View className='add-your-first-friend-to-your-squad-rating-card-image'>
              <img src='https://cdn.shopify.com/s/files/1/0569/9957/5718/files/Rating_cardx_73e94f30-deea-492d-9335-7fb2b3055da0.png?v=1695058005' />
            </View>
          )}
        </View>
      </View>
    </section>
  )
}
